module.exports = __webpack_public_path__ + "media/assets/images/weather-button-5d388d1e6102e57ab7546443ca474675.svg";